(function () {
  function initUGCHomeVideos(root) {
    root = root || document;

    root.querySelectorAll('.ugc-home-videos').forEach(function (section) {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';

      var track = section.querySelector('[data-ugc-track]');
      var prevButton = section.querySelector('[data-ugc-prev]');
      var nextButton = section.querySelector('[data-ugc-next]');
      if (!track) return;

      function getYouTubeId(rawUrl) {
        try {
          var url = new URL(rawUrl);
          var host = url.hostname.replace(/^www\./, '').replace(/^m\./, '');
          var parts = url.pathname.split('/').filter(Boolean);
          var videoId = null;

          if (host === 'youtu.be') {
            videoId = parts[0];
          } else if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
            if (parts[0] === 'shorts' || parts[0] === 'embed') {
              videoId = parts[1];
            } else {
              videoId = url.searchParams.get('v');
            }
          }

          return videoId && /^[A-Za-z0-9_-]{11}$/.test(videoId) ? videoId : null;
        } catch (error) {
          return null;
        }
      }

      function updateArrows() {
        if (!prevButton || !nextButton) return;
        var maxScroll = track.scrollWidth - track.clientWidth;
        prevButton.disabled = track.scrollLeft <= 3;
        nextButton.disabled = track.scrollLeft >= maxScroll - 3;
      }

      var validVideoCount = 0;

      section.querySelectorAll('[data-youtube-url]').forEach(function (media) {
        var videoId = getYouTubeId(media.dataset.youtubeUrl);
        var card = media.closest('.ugc-home-videos__card');

        if (!videoId) {
          if (card) card.remove();
          return;
        }
        validVideoCount++;

        var playButton = media.querySelector('.ugc-home-videos__play');
        var image = document.createElement('img');
        image.src = 'https://i.ytimg.com/vi/' + videoId + '/maxresdefault.jpg';
        image.alt = media.dataset.videoTitle || 'Kullanıcı videosu';
        image.loading = 'lazy';
        image.onerror = function () {
          image.src = 'https://i.ytimg.com/vi/' + videoId + '/hqdefault.jpg';
        };
        media.insertBefore(image, playButton);

        playButton.addEventListener('click', function () {
          var iframe = document.createElement('iframe');
          iframe.src = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1&playsinline=1&rel=0&modestbranding=1';
          iframe.title = media.dataset.videoTitle || 'Kullanıcı videosu';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;
          media.innerHTML = '';
          media.appendChild(iframe);
        });
      });

      if (validVideoCount === 0) {
        section.remove();
        return;
      }

      function scrollAmount() {
        var card = track.querySelector('.ugc-home-videos__card');
        return card ? card.getBoundingClientRect().width + 20 : 300;
      }

      if (prevButton) {
        prevButton.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      if (nextButton) {
        nextButton.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initUGCHomeVideos(document); }, { once: true });
  } else {
    initUGCHomeVideos(document);
  }

  // Shopify tema düzenleyicisinde section yeniden yüklendiğinde (ayar değişince) tekrar çalıştır.
  document.addEventListener('shopify:section:load', function (event) {
    initUGCHomeVideos(event.target);
  });
})();
